import {useEffect, useState} from "react";
import {Axios} from "api";
import {shuffle} from "common/utils";
import {captureException, captureMessage} from "@sentry/nextjs";
import styles from "components/sections/curation/ProductBasedCurationListSection.module.scss";
import {CurationSection} from "components/sections/curation/CurationSection";
import classNames from "classnames";


export const ProductBasedCurationListSection = (props) => {
    const {curationKey, location, productOptionIds, isInitialized, onPouchAdd, isAddToPouchVisible, isFoldable} = props;
    const [isLoading, setIsLoading] = useState(false);
    const [curations, setCurations] = useState([]);

    useEffect(() => {
        if (!isInitialized) return;
        fetchCuration();
    }, [productOptionIds, isInitialized]);

    const handlePouchAdd = (product) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ProductBasedCurationListSectionPouchAddButtonClick',
            {
                curationKey,
                location,
                productId: product.id,
                productName: product.name,
            }
        );
        onPouchAdd();
    };


    const fetchCuration = async () => {
        if (isLoading) {
            return;
        }
        try {
            setIsLoading(true);
            const data = {
                'option_ids': productOptionIds,
                'exclude_ids': productOptionIds,
            }
            const res = await Axios.post(`v1/curation/product/${curationKey}/`, data);
            console.log('fetchCuration', res.data, data);
            if (res.status < 400) {
                const originalCurationIds = curations.map((curation) => {
                    return curation.id;
                });
                const newCurations = res.data.curations.filter(
                    (curation) => {
                        return !originalCurationIds.includes(curation.id)
                    }
                );
                if (newCurations.length > 0) {
                    const curations = shuffle(res.data.curations);
                    setCurations(curations);
                }
            } else {
                captureMessage(JSON.stringify(res.data));
            }
        } catch (e) {
            captureException(e);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.curationListContainer}>
            {
                curations.map((curation, idx) => {
                    return (
                        <>
                            <CurationSection
                                key={`${curation.title}_${idx}`} curation={curation} location={location}
                                curationIdx={idx} onPouchAdd={handlePouchAdd}
                                isAddToPouchVisible={isAddToPouchVisible}
                                isFoldable={isFoldable}
                                isFoldedFromStart={idx > 0}
                            />
                            <div className={classNames(styles.mobileBorder, styles.curationBorder)}/>
                        </>
                    )
                })
            }
        </div>

    )
}
